"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import useNewsletterStatus from '~/hooks/useNewsletterStatus';

const PromoBanner = () => {
  const { isLoading, shouldPromote } = useNewsletterStatus();

  const [hover, setHover] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const styles = {
    banner: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      background: "linear-gradient(135deg, #0f4c8a 0%, #1a6fb5 60%, #2a8ad4 100%)",
      borderRadius: "8px",
      overflow: "hidden",
      width: "100%",
      maxWidth: "none",
      margin: "20px 0",
      position: "relative",
    },
    circleTop: {
      position: "absolute",
      top: "-80px",
      right: "-80px",
      width: "340px",
      height: "340px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.05)",
      pointerEvents: "none",
    },
    circleBottom: {
      position: "absolute",
      bottom: "-60px",
      left: "40px",
      width: "220px",
      height: "220px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.04)",
      pointerEvents: "none",
    },
    image: {
      flex: 1,
      minWidth: isMobile ? "unset" : "40%",
      width: isMobile ? "100%" : undefined,
      height: isMobile ? "200px" : undefined,
      background: "url('/static/img/sale/cart-newsletter.jpg') center/cover no-repeat",
      position: "relative",
      zIndex: 1,
    },
    content: {
      flex: 1.2,
      padding: isMobile ? "30px 20px" : "40px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      color: "#ffffff",
      position: "relative",
      zIndex: 1,
    },
    h2: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      margin: "0 0 15px 0",
      lineHeight: 1.2,
      fontWeight: 700,
      color: "#ffffff",
    },
    p: {
      fontSize: "1.1rem",
      marginBottom: "25px",
      lineHeight: 1.5,
      opacity: 0.95,
      color: "#ffffff",
    },
    cta: {
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "transparent",
      color: "#ffffff",
      textDecoration: "none",
      fontWeight: 600,
      fontSize: "1.1rem",
      border: "2px solid white",
      padding: "12px 24px",
      borderRadius: "4px",
      width: "fit-content",
    },
    svg: {
      width: "30px",
      height: "30px",
      marginLeft: "10px",
      verticalAlign: "middle",
      transition: "transform 0.3s",
      transform: hover ? "matrix(1, 0, 0, 1, 14, 0)" : "matrix(1, 0, 0, 1, 9, 0)",
    },
  };

  if (isLoading || !shouldPromote) return null;

  return (
    <div className="">
      <div style={styles.banner}>
        <div style={styles.circleTop} />
        <div style={styles.circleBottom} />
        <div style={styles.image} />
        <div style={styles.content}>
          <h2 style={styles.h2}>Deine 5€ warten<br />Jetzt zum Newsletter anmelden</h2>
          <p style={styles.p}>
            Melde dich jetzt für unsere exklusiven Angebote an und erhalte einen
            5€ Online-Gutschein für deinen nächsten Einkauf.
          </p>
          <Link
            href="/customer-service/newsletter-signup"
            style={styles.cta}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            Jetzt anmelden &amp; sparen
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="27"
              viewBox="0 0 32 32"
              fill="currentColor"
              style={styles.svg}
            >
              <path
                d="m26.442 15.558-4-4a.625.625 0 0 0-.884.884l2.933 2.933H6a.625.625 0 0 0 0 1.25h18.491l-2.933 2.933a.625.625 0 0 0 .884.884l4-4a.627.627 0 0 0 0-.884Z"
                fill="currentColor"
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;